import { render } from "./Comission.vue?vue&type=template&id=8b6a2d52&scoped=true"
import script from "./Comission.vue?vue&type=script&lang=js"
export * from "./Comission.vue?vue&type=script&lang=js"

import "./Comission.vue?vue&type=style&index=0&id=8b6a2d52&scoped=true&lang=less"

import exportComponent from "E:\\rt\\AndroidSdk\\qiugxiu\\web-tuiguangzu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6a2d52"]])

export default __exports__